<template>
  <product-detail
    v-if="product"
    :key="$route.path"
    :show-in-the-press="false"
    :featured-press="featuredPress"
    v-bind="product"
    :product="product"
    :shopify-product="shopifyProduct"
    :path="path"
    class="product--realitywear"
  >
    <template v-if="product.gallery && product.gallery.gallery" #after-header>
      <page-section v-if="product.gallery.gallery.length > 0" centered>
        <div class="relative">
          <marquee speed="40" constant>
            <div
              :class="product.gallery.gallery.length > 1 ? '' : 'w-win-w'"
              class="flex flex-no-wrap justify-center space-around py-y-gutter-sm"
              style="perspective: var(--win-height)"
            >
              <float
                v-for="(slide, i) in product.gallery.gallery"
                :key="`product-gallery-slide-${i}`"
                :speed="i % 2 ? 4 : 7"
                :offset="i % 2 ? '5%' : '-6%'"
              >
                <window-3d
                  :animate-left="i % 2 ? true : false"
                  :animate-right="i % 2 ? false : true"
                  class="flex-auto mx-2em"
                >
                  <sanity-media v-bind="slide" no-ratio cover fluid />
                </window-3d>
              </float>
            </div>
          </marquee>
          <div
            v-if="product.gallery.link"
            class="text-center mt-y-gutter-sm md:mt-0 md:absolute md:left-0 md:bottom-0 md:w-full md:text-right"
          >
            <div class="container">
              <cta
                tag="recess-link"
                :sanity-link="product.gallery.link"
                fill
                class="mr-x-gutter-sm mb-y-gutter-sm"
              >
                {{
                  product.gallery.link.title ||
                    (product.gallery.link.page
                      ? product.gallery.page.title
                      : 'Learn more')
                }}
              </cta>
            </div>
          </div>
        </div>
      </page-section>
    </template>
  </product-detail>
</template>

<script>
import page from '~/mixins/page'
import productDetail from '~/mixins/product-detail'
import ProductDetail from '~/components/shop/products/product-detail.vue'

export default {
  components: {
    ProductDetail
  },

  mixins: [page, productDetail],

  data: () => ({
    product: null,
    shopifyProduct: null,
    path: null
  })
}
</script>
